import { SDCredentialValues } from "../../../types/types";

export function buildCredentialJson(values: SDCredentialValues) {
  const coreFieldsObj: Record<string, string> = {};
  for (const { key, value } of values.coreFields) {
    coreFieldsObj[key] = value;
  }
  const subjectAttrsObj: Record<string, string> = {};
  for (const { key, value } of values.subjectAttrs) {
    subjectAttrsObj[key] = value;
  }
  return {
    '@context': values.contexts,
    ...coreFieldsObj,
    credentialSubject: {
      holder: values.holder,
      type: values.subjectType,
      customAttribute: values.customAttributes,
      ...subjectAttrsObj,
    },
  };
}